import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import { MetricWidgetBase } from '@components/overview-dashboard/common/mixins';

export const DimensionTableWrapper = styled.div`
    ${MetricWidgetBase};
    margin-left: 0px;
    padding-left: 0px;

    ${breakpoint('tablet')`
        width: 100%;
    `};

    ${breakpoint('desktop')`
        width: 32%;
        height: 450px;
    `};

    ${breakpoint('mobile')`
        width: 100%;
    `};

    .conviva-dimension-table__header-row .title {
      display: flex;
      flex-grow: 1;
      justify-content: flex-end;
      margin-right: 5px;
    }

    .conviva-dimension-table__row-cell{
      padding-left: 0px !important;
    }
`;

export const StyledEllipsis = styled.div`
  font-size: 1rem;
  font-weight: 200;
  width: 100%;
  padding-top: 3px;
  cursor: pointer;
  &:hover {
    color: #0046FF;
  }
`;

export const StyledCell = styled.div`
  font-size: 1rem;
  font-weight: 200;
  width: 100%;
`;

export const TableWrapper = styled.div`
  height: 400px;
  position: relative;
`;
